'use client'

import { Text } from '@macarongfactory/web-ui'

import { formatPreviousYearMonth } from '@/features/seoPlaceDetail/lib/formatPlaceIntroductionDate'

const PlaceDataDisclaimer = () => {
  const yearMonth = formatPreviousYearMonth()

  return (
    <section
      aria-label='데이터 출처'
      className='h-[128px] bg-background-neutral-weak px-dimension-x5 py-dimension-x4'
    >
      <Text
        variant='title-2-medium'
        color='text-foreground-neutral-alternative'
        className='break-keep'
      >
        {`이 페이지의 시공 건수 · 리뷰 수는 마이클 앱의 ${yearMonth}까지 누적 실거래 데이터 기준으로 집계했습니다.`}
      </Text>
    </section>
  )
}

export default PlaceDataDisclaimer
